<script>
    import {Line} from  'vue-chartjs'

    export default {
        extends: Line,
        props: {
            container: null,
            /**
             * 表示対象年月
             */
            targetMonth: {
                type: Object,
                default: function () {
                    return {year:2020, month:1}
                }
            },
            /**
             * 終了した予定を表示するか否か
             */
            viewCompletedWork: {
                type: Boolean,
                default: false
            },
            /**
             * 対象の場所
             */
            place: null,
            /**
             * 登録されている全作業種類
             */
            workTypes: null
        },
        data () {
            return {
                data: {
                    datasets: [
                        {
                            label: 'Line Dataset',
                            data: [{x: "2020-08-01", y:1.5}, {x: "2020-08-10", y:1.5}],
                            borderColor: '#CFD8DC',
                            fill: false,
                            type: 'line',
                            lineTension: 0.0,
                            borderWidth: 5
                        },
                        {
                            label: 'Line Dataset',
                            data: [{x: "2020-08-04", y:0.5}, {x: "2020-08-05", y:0.5}],
                            borderColor: '#FFD8DC',
                            fill: false,
                            type: 'line',
                            lineTension: 0.0,
                            borderWidth: 5
                        },
                        {
                            label: 'Line Dataset',
                            data: [{x: "2020-08-21", y:1.5}, {x: "2020-08-31", y:1.5}],
                            borderColor: '#CFD8DC',
                            fill: false,
                            type: 'line',
                            lineTension: 0.0,
                            borderWidth: 5
                        },
                        {
                            label: 'Line Dataset',
                            data: [{x: "2020-08-21", y:0.5}, {x: "2020-08-21", y:0.5}],
                            borderColor: '#FFD8DC',
                            fill: false,
                            type: 'line',
                            lineTension: 0.0,
                            borderWidth: 5
                        },
                    ]
                },
                options: {
                    maintainAspectRatio: false,
                    legend: {
                        display: false
                    },
                    tooltips: {
                        enabled: true,
                    },
                    scales: {
                        yAxes: [
                            {
                                scaleLabel: {
                                    display: false,
                                },
                                ticks: {
                                    beginAtZero: true,
                                    padding: 10,
                                },
                                gridLines: {
                                    color: [,,"rgba(0,0,0)",,"rgba(0,0,0)"],
                                    tickMarkLength: 0
                                }
                            }
                        ],
                        xAxes: [
                            {
                                scaleLabel: {
                                    display: false,
                                    labelString: '日'
                                },
                                type: "time",
                                time: {
                                    unit: "day",
                                },
                                gridLines: {
                                    color: [,,"rgba(255,0,0)"],
                                    tickMarkLength: 0
                                },
                                ticks: {
                                    maxRotation: 0,
                                    autoSkip: false,
                                    source: "date",
                                    padding: 10,
                                    min: "2020-08-01",
                                    max: "2020-08-31",
                                }
                            }
                        ]
                    }
                },
                // viewTargetWorks: []
            }
        },
        computed: {
            viewTargetWorks: function () {
                const works = []
                for (var i=0; i<this.place.works.length; i++) {
                    if (!this.place.works[i].isCompleted || this.viewCompletedWork) {
                        works.push(this.place.works[i])
                    }
                }
                return works
            }
        },
        watch: {
            /**
             * 変更監視:対象年
             */
            "targetMonth.year": function () {
                console.log("ChartPlaceWork","targetMonth.year changed")
                this.refresh()
            },
            /**
             * 変更監視:対象月
             */
            "targetMonth.month": function () {
                console.log("ChartPlaceWork","targetMonth.month changed")
                this.refresh()
            },
            /**
             * 変更監視:終了作業の表示/非表示
             */
            viewCompletedWork: function () {
                console.log("ChartPlaceWork","viewCompletedWork changed")
                this.refresh()
            },
            /**
             * 変更監視:表示対象の作業
             */
            viewTargetWorks: function () {
                console.log("ChartPlaceWork","viewTargetWorks changed")
                this.refresh()
            },
            /**
             * 変更監視:場所が持つ全作業
             */
            "place.works": {
                handler: function (value, old) {
                    console.log("ChartPlaceWork","place changed")
                    this.refresh()
                },
                deep: true
            },
            /**
             * 変更監視:登録されている作業種類
             */
            workTypes: {
                handler: function (value, old) {
                    console.log("ChartPlaceWork","workTypes changed")
                    this.refresh()
                },
                deep: true
            }
        },
        created: function () {
        },
        // mounted () {
        //     const self = this
        //     console.log("ChartPlaceWork","mounted")
        //     this.refresh()
        // },
        mounted: function () {
            const self = this

            /**
             * Chartjs に作業のツールチップを常時表示するようプラグインを追加(スマホ用)
             */
            if (this.$vuetify.breakpoint.xs) {
                this.addPlugin (
                    {
                        beforeRender: function (chart) {
                            // console.log("beforeRender")
                            chart.pluginTooltips = []
                            chart.config.data.datasets.forEach(function (dataset, i) {
                                // if (dataset.additionalData != null) console.log(dataset.additionalData)
                                if (dataset.additionalData != null && dataset.additionalData.lineType == "schedule_label") {
                                    // console.log("schedule_label")
                                    chart.getDatasetMeta(i).data.forEach (function (sector, j) {
                                        chart.pluginTooltips.push (
                                            new Chart.Tooltip (
                                                {
                                                    _chart: chart.chart,
                                                    _chartInstance: chart,
                                                    _data: chart.data,
                                                    _options: chart.options.tooltips,
                                                    _active: [sector]
                                                },
                                                chart
                                            )
                                        )
                                    })
                                }
                            })
                        },
                        afterDraw: function (chart, easing) {
                            Chart.helpers.each(chart.pluginTooltips, function (tooltip) {
                                tooltip.initialize()
                                tooltip.update()
                                tooltip.transition(easing).draw()
                            })
                        }
                    }
                )
            }

            // console.log("ChartPlaceWork", "mounted")
            this.refresh()
        },
        methods: {
            /**
             * チャート更新
             */
            refresh: function () {
                const self = this

                /**
                 * X軸設定
                 */
                const lastDate = new Date(this.targetMonth.year, this.targetMonth.month, 0)
                this.options.scales.xAxes[0].ticks.min = this.targetMonth.year + "/" + this.targetMonth.month + "/01"
                this.options.scales.xAxes[0].ticks.max = this.targetMonth.year + "/" + this.targetMonth.month + "/" + lastDate.getDate()
                this.options.scales.xAxes[0].ticks.callback = function (value, index,values) {
                    const d = new Date(values[index].value)
                    if (d.getDate() == 1) {
                        return (d.getMonth()+1) + "/1"
                    } else {
                        if (self.$vuetify.breakpoint.xs) {      // スマホでは、X軸のラベルは1日もしくは日曜日に限定する
                            if (d.getDay() != 0) {
                                return ""
                            }
                        }
                        return d.getDate()
                    }
                }
                this.options.scales.xAxes[0].gridLines.color = []
                for (var day=1; day<=lastDate.getDate(); day++) {
                    const d = new Date(this.targetMonth.year, this.targetMonth.month - 1, day)
                    if (d.getDay() == 0) {
                        this.options.scales.xAxes[0].gridLines.color.push("rgba(255,0,0,0.5)")
                    } else {
                        this.options.scales.xAxes[0].gridLines.color.push("rgba(0,0,0,0.1)")
                    }
                }

                /**
                 * Y軸設定
                 */
                this.options.scales.yAxes[0].ticks.min = 0
                this.options.scales.yAxes[0].ticks.max = this.viewTargetWorks.length * 2
                this.options.scales.yAxes[0].ticks.stepSize = 1
                this.options.scales.yAxes[0].ticks.callback = function (value, index, values) {
                    if (self.$vuetify.breakpoint.xs) return " "     // スマホでは、Y軸ラベルを描画しない
                    if (value % 2 == 1) {
                        const row = Math.floor(value / 2)
                        const work = self.viewTargetWorks[self.viewTargetWorks.length - row - 1]
                        return  work.name
                    } else {
                        return ""
                    }
                }
                this.options.scales.yAxes[0].gridLines.color = []
                for (var y=this.viewTargetWorks.length * 2; y>=1; y--) {    // y軸の色設定は、上から順に
                    if (y % 2 == 0 && y != this.viewTargetWorks.length * 2) {
                        this.options.scales.yAxes[0].gridLines.color.push("rgba(0,0,0,0.5)")
                    } else {
                        this.options.scales.yAxes[0].gridLines.color.push("rgba(0,0,0,0.1)")
                    }
                }

                this.options.tooltips.callbacks = {
                    title: function (tooltipItem, chart) {
                        const additionalData = chart.datasets[tooltipItem[0].datasetIndex].additionalData
                        if (self.$vuetify.breakpoint.xs) {
                            if (additionalData.lineType == "schedule_label") {
                                return additionalData.work.name
                            }
                            return ""
                        } else {
                            // スマホ以外
                            switch (additionalData.lineType) {
                                case "schedule":
                                    if (additionalData.work.scheduleDate.startDate == "" && additionalData.work.scheduleDate.endDate == "") {
                                        return [
                                            additionalData.work.name,
                                            "期間未設定"
                                        ]
                                    }
                                    return [
                                        additionalData.work.name,
                                        additionalData.work.scheduleDate.startDate + "～" + additionalData.work.scheduleDate.endDate
                                    ]
                                case "record":                                    
                                    return additionalData.work.name
                            }
                        }
                    },
                    label: function (tooltipItem, chart) {
                        // const additionalData = chart.datasets[tooltipItem[0].datasetIndex].additionalData
                    }
                }

                // スマホの時のツールチップの設定(背景色を透明にする)
                if (this.$vuetify.breakpoint.xs) {
                    this.options.tooltips.titleFontSize = 9
                    this.options.tooltips.backgroundColor = "rgba(255,255,0,0.1)"
                    this.options.tooltips.titleFontColor = "rgba(0,0,0,0.5)"
                    this.options.tooltips.titleFontStyle = "bold"
                    this.options.tooltips.caretPadding = 0
                    this.options.tooltips.caretSize = 0
                    this.options.tooltips.titleMarginBottom = 0
                    this.options.tooltips.bodySpacing = 0
                    this.options.tooltips.yPadding = 3
                }

                /**
                 * データセット
                 */
                this.data.datasets = []
                this.viewTargetWorks.forEach(function(work, index){
                    /**
                     * 予定
                     */
                    const dataset = {
                        label: work.name,
                        data: [],
                        borderColor: "#CFD8DC",
                        fill: false,
                        type: "line",
                        lineTension: 0.0,
                        borderWidth: 5,
                        additionalData: {
                            work: work,
                            lineType: "schedule"
                        },
                        pointRadius: 0
                    }
                    dataset.data.push(
                        {
                            x: work.scheduleDate.startDate != "" ? work.scheduleDate.startDate : "2020/01/01",
                            y: self.viewTargetWorks.length * 2 - index * 2 - 1 + 0.5
                        }
                    )
                    dataset.data.push(
                        {
                            x: work.scheduleDate.endDate != "" ? work.scheduleDate.endDate : "2020/12/31",
                            y: self.viewTargetWorks.length * 2 - index * 2 - 1 + 0.5
                        }
                    )
                    self.data.datasets.push(dataset)

                    /** 予定のラベル用(スマホのみ) */
                    if (self.$vuetify.breakpoint.xs) {
                        const labelDataset = {
                            label: work.name,
                            data: [],
                            borderColor: "#CFD8DC",
                            fill: false,
                            type: "line",
                            lineTension: 0.0,
                            borderWidth: 5,
                            additionalData: {
                                work: work,
                                lineType: "schedule_label"
                            },
                            pointRadius: 0
                        }
                        labelDataset.data.push(
                            {
                                x: self.options.scales.xAxes[0].ticks.min,
                                y: self.viewTargetWorks.length * 2 - index * 2 - 0.5
                            }
                        )
                        self.data.datasets.push(labelDataset)
                    }

                    /**
                     * 実績
                     */
                    if (work.records != null) {
                        var lastRecordDate = ""
                        var lastDataset = null
                        work.records.forEach(function(record, recordIndex, records){
                            var interval = 0
                            if (lastRecordDate != "") {
                                interval = ((new Date(record.date)) - (new Date(lastRecordDate))) / 86400000
                            }
                            if (lastDataset == null || lastRecordDate == "" || interval > 1) {
                                // console.log(record.date, lastRecordDate, interval)
                                lastDataset = {
                                    label: work.name,
                                    data: [
                                        {
                                            x: record.date,
                                            y: self.viewTargetWorks.length * 2 - index * 2 - 1 - 0.5
                                        },
                                        {
                                            x: record.date,
                                            y: self.viewTargetWorks.length * 2 - index * 2 - 1 - 0.5
                                        }
                                    ],
                                    borderColor: "#FFD8DC",
                                    fill: false,
                                    type: "line",
                                    lineTension: 0.0,
                                    borderWidth: 5,
                                    additionalData: {
                                        work: work,
                                        lineType: "record",
                                        record: record
                                    },
                                    pointRadius: self.$vuetify.breakpoint.xs ? 2 : 3
                                }
                                self.data.datasets.push(lastDataset)
                                // console.log("start", record.date)
                            } else {
                                lastDataset.data[1].x = record.date
                                // console.log("end date update", record.date)
                            }
                            lastRecordDate = record.date
                        })
                    }
                })

                this.$refs.canvas.height = (this.viewTargetWorks.length <=2 ? 120 : this.viewTargetWorks.length * 40) //40
                // console.log("表示対象の作業", this.viewTargetWorks, this.$refs.canvas.height)
                // this.$refs.canvas.style.height = (this.viewTargetWorks.length * 40) + "px"
                // this.container.style.height = (this.viewTargetWorks.length * 40) + "px"

                // console.log(this.$refs.canvas.height, this.$refs.canvas.style.height)

                this.renderChart(this.data, this.options)
            },
            reRender: function () {
                this.renderChart(this.data, this.options)
            },
            /**
             * 指定されたIDをもつ作業種類を取得
             */
            getWorkType: function (id) {
                // console.log("workItem", id)
                return this.workTypes[this.workTypes.findIndex((v)=>v.workTypeID == id)]
            },
        }
    }
</script>

                data: {
                    datasets: [
                        {
                            label: 'Line Dataset',
                            data: [{x: "2020-08-01", y:1.5}, {x: "2020-08-10", y:1.5}],
                            borderColor: '#CFD8DC',
                            fill: false,
                            type: 'line',
                            lineTension: 0.0,
                            borderWidth: 5
                        },
                        {
                            label: 'Line Dataset',
                            data: [{x: "2020-08-04", y:0.5}, {x: "2020-08-05", y:0.5}],
                            borderColor: '#FFD8DC',
                            fill: false,
                            type: 'line',
                            lineTension: 0.0,
                            borderWidth: 5
                        },
                        {
                            label: 'Line Dataset',
                            data: [{x: "2020-08-21", y:1.5}, {x: "2020-08-31", y:1.5}],
                            borderColor: '#CFD8DC',
                            fill: false,
                            type: 'line',
                            lineTension: 0.0,
                            borderWidth: 5
                        },
                        {
                            label: 'Line Dataset',
                            data: [{x: "2020-08-21", y:0.5}, {x: "2020-08-21", y:0.5}],
                            borderColor: '#FFD8DC',
                            fill: false,
                            type: 'line',
                            lineTension: 0.0,
                            borderWidth: 5
                        },
                    ]
                },


